import React from 'react';
import { useLocation } from 'react-router-dom';
import { LayoutContext } from 'contexts';

const AppTitleSelector: React.FC = () => {
  const { pathname } = useLocation();
  const { setAppTitle } = React.useContext(LayoutContext);

  const isExternalPath = () => {
    const rets = pathname.search(/\/rets\/.+/g) !== -1;
    const dash = pathname.search(/\/dash\/.+/g) !== -1;
    return rets || dash;
  };

  const pickAppTitle = () => {
    // Generic pathnames should go last

    if (isExternalPath()) return '';

    if (pathname.includes('/listing/list/team/')) return 'My Team';
    if (pathname.includes('/listing/list/favorites/')) return 'My Favorites';
    if (pathname.includes('/listing/list/admin/')) return 'Draft Listings';
    if (pathname.includes('/listing/list/deleted/')) return 'Deleted Listings';
    if (pathname.includes('/listing/merge/options')) {
      return 'Merge / Combine Listings';
    }
    if (pathname.includes('/listing/merge?combine')) return 'Combine Listings';
    if (pathname.includes('/listing/merge')) return 'Merge Listings';
    if (pathname.includes('/listing/network_map')) return 'Exclusive Network';
    if (pathname.includes('/announcement/list')) {
      return 'Brokerage Announcements';
    }
    if (pathname.includes('/announcement/new')) return 'New Announcement';
    if (pathname.includes('/notification/list')) return 'Notification Centre';
    if (pathname.includes('/open_houses/add')) return 'Add Open House';
    if (pathname.includes('/needs/new')) return 'New Have/Want';
    if (pathname.includes('/admin/dashboard')) return 'Admin Queue';
    if (pathname.includes('/admin/answering')) return 'Answering Service';
    if (pathname.includes('/admin')) return 'Admin';
    if (pathname.includes('/assets')) return 'Brokerage Files';
    if (pathname.includes('/lockboxes')) return 'Manage Lock Boxes';
    if (pathname.includes('/inbox')) return 'My Messages';
    if (pathname.includes('/profile')) return 'Account Settings';
    if (pathname.search(/\/listing\/.+\/view/g) !== -1) return 'View Listing';
    if (pathname.search(/\/listing\/.+\/offer_message/g) !== -1) {
      return 'Message Showing Agents';
    }
    if (pathname.search(/\/listing\/.+\/offer_settings/g) !== -1) {
      return 'Offer Settings';
    }
    if (pathname.search(/\/listing\/.+\/offer/g) !== -1) return 'Offers';
    if (pathname.search(/\/listing\/.+\/appointments\/book/g) !== -1) {
      return 'Book Showing';
    }
    if (pathname.search(/\/listing\/.+\/appointments\/config/g) !== -1) {
      return 'Showing Configuration';
    }
    if (
      pathname.search(/\/listing\/.+\/appointments\/feedback_settings/g) !== -1
    ) {
      return 'Feedback Settings';
    }
    if (pathname.search(/\/listing\/.+\/appointments/g) !== -1) {
      return 'Listing Showings';
    }
    if (pathname.search(/\/appointments\/.+\/action/g) !== -1) {
      return 'Showing Request';
    }

    return '';
  };

  React.useEffect(() => {
    const appTitle = pickAppTitle();
    setAppTitle(appTitle);
  }, [pathname]);

  return null;
};

export default AppTitleSelector;
